import { styled } from '@grupoboticario/flora-react-system'
import { StyledInternalPlaceholder, StyledLabel } from '../Label/styles'
import { StyledInput, InputButtonWrapper, InputButton } from '../../styles'

export const FocusWrapper = styled('div', {
  position: 'relative',
  width: '100%',

  [`& > ${InputButtonWrapper}`]: {
    boxShadow: '0 0 0 0.3125rem transparent',
    transitionDuration: '300ms',
    transitionTimingFunction: 'ease-out',
    transitionProperty: 'border-color, box-shadow, outline-color',
  },

  variants: {
    labelPosition: {
      internal: {},
      external: {},
    },
    hasValue: {
      true: {},
    },
    hasEffect: {
      true: {},
    },
    surfaceColor: {
      light: {
        color: '$nonInteractivePredominant',
      },
      dark: {
        color: '$nonInteractiveAltPredominant',

        '&:placeholder': {
          color: '$nonInteractiveAltAuxiliar',
        },
      },
    },
    hasButton: {
      true: {
        [`& ${InputButtonWrapper}`]: {
          boxShadow: '0 0 0 0.3125rem transparent',
        },

        [`& ${StyledInput}`]: {
          '&:hover:not(:focus-visible)': {
            boxShadow: 'none',
          },
        },

        [`&:has(${StyledInput}:focus) ${InputButton}`]: {
          position: 'inherit',
          zIndex: 'inherit',
        },
      },
    },
    clicked: {
      true: {},
    },
    status: {
      neutral: {},
      success: {},
      error: {},
      warning: {},
      loading: {},
    },
    disabled: {
      true: {},
    },
  },

  compoundVariants: [
    {
      labelPosition: 'internal',
      hasEffect: true,
      css: {
        [`&:has(${StyledInput}:focus)`]: {
          [`${StyledLabel}`]: {
            fontSize: '$auxiliar',
            lineHeight: '1.3333333333',
            paddingTop: '$3',

            [`${StyledInternalPlaceholder}`]: {
              opacity: '0',
            },
          },
        },
      },
    },
    {
      labelPosition: 'internal',
      hasValue: true,
      css: {
        [`${StyledLabel}`]: {
          fontSize: '$auxiliar',
          lineHeight: '1.3333333333',
          paddingTop: '$3',

          [`${StyledInternalPlaceholder}`]: {
            opacity: '0',
          },
        },
      },
    },

    {
      hasButton: true,
      clicked: false,
      surfaceColor: 'light',
      css: {
        [`&:hover:has(${StyledInput}:not(:focus-visible)) ${InputButtonWrapper}`]: {
          boxShadow: '0 0 0 0.3125rem $colors$nonPrimaryButtonHover',
        },

        [`&:hover ${StyledInput}:not(:focus-visible)`]: {
          borderColor: '$actionableDefault',
          outlineColor: '$actionableDefault',
        },
      },
    },
    {
      hasButton: true,
      clicked: false,
      surfaceColor: 'dark',
      css: {
        [`&:hover:has(${StyledInput}:not(:focus-visible)) ${InputButtonWrapper}`]: {
          boxShadow: '0 0 0 0.3125rem $colors$nonPrimaryButtonAltHover',
        },

        [`&:hover ${StyledInput}:not(:focus-visible)`]: {
          borderColor: '$actionableAlt',
          outlineColor: '$actionableAlt',
        },
      },
    },

    {
      hasButton: true,
      status: 'loading',
      css: {
        [`& ${StyledInput}, &:hover ${StyledInput}`]: {
          borderColor: '$nonInteractiveOutline',
          outlineColor: 'transparent',
        },

        [`&:hover > ${InputButtonWrapper}`]: {
          boxShadow: 'none',
        },
      },
    },

    {
      disabled: true,
      surfaceColor: 'light',
      css: {
        [`&:hover ${StyledInput}`]: {
          borderColor: '$nonInteractiveOutline',
        },

        [`&:hover > ${InputButtonWrapper}`]: {
          boxShadow: 'none',
        },
      },
    },
    {
      disabled: true,
      surfaceColor: 'dark',
      css: {
        [`&:hover ${StyledInput}`]: {
          borderColor: '$nonInteractiveAltOutline',
        },

        [`&:hover > ${InputButtonWrapper}`]: {
          boxShadow: 'none',
        },
      },
    },
  ],
})
